/*
 this file is for types that have special meaning in this application
 */
import * as React from 'react'

import {
  FormikBag,
  InjectedFormikProps,
} from 'formik'

export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>

export type Subtract<T, K> = Omit<T, keyof K>

export interface PrimitiveRoute {
  name: string
  path: string
  icon?: React.ReactElement<any>
}

export interface RichRoute extends PrimitiveRoute {
  component: any,
}

export type SubRouting = RichRoute []

export interface TopRoute extends PrimitiveRoute {
  subrouting: SubRouting
}

export type Routing = TopRoute []

/*
 SPECIAL FORMIK TYPES
 */
export type FormikHandleSubmit<Props, Values> = (
  values: Values,
  formikBag: FormikBag<Props, Values>,
) => void

/* a dumb component formchunk that is hooked up to formik */
export type FormikFormChunkProps<Fields,
  AdditionalFormikProps = {},
  AdditionalFormChunkProps = {}> =
    InjectedFormikProps<AdditionalFormikProps, Fields>
  & AdditionalFormChunkProps

export type Sector =
  | 'education'
  | 'agriculture'
  | 'technology'
  | 'medicine'
  | 'customer service'
  | ''

export interface OpenerProps {
  onClick: () => void
}

export type ReactComponent<T> =
  | React.SFC<T>
  | React.ComponentClass<T>
  | React.ComponentType<T>
  | string

export enum UIState {
  loading = 'loading',
  loaded = 'loaded',
  failed = 'failed',
}

export interface GenericObject {
  [ property: string ]: any
}

export enum ExperienceType {
  NORMAL = 'normal',
  COACHING = 'coaching',
}



// WEBPACK FOOTER //
// ./src/types.ts